import { useQuery } from "@tanstack/react-query";
import { useState } from 'react'
import axios from "../../api/axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

function useGetData(type) {
    const initialState = {
        limit: 10,
        pageNo: 0,
    }
    const [getFormData, setGetFormData] = useState(initialState)
    const handleGetDataList = useQuery([type, getFormData], () => getData(getFormData), {
        refetchOnWindowFocus: false
    })
    const getData = async (getFormData) => {
        let TOKEN = cookies.get("_pn_token");
        let fd = new FormData()
        for (var key in getFormData) {
            fd.append(key, getFormData[key]);
        }
        const response = await axios({
            method: "POST",
            data: fd,
            url: `/getFeesParticularList`,
            headers: { Authorization: TOKEN ? `Bearer ${TOKEN}` : '', }
        })
        return response.data
    }
    return { getFormData, setGetFormData, handleGetDataList }
}

export default useGetData